"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyInput = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = require("../../Button");
const CopyInput_styles_1 = require("./CopyInput.styles");
const helpers_1 = require("../../helpers");
const Icon_1 = require("../../Icon");
const icons_1 = require("../../icons");
const StackView_1 = require("../../StackView");
exports.CopyInput = (0, helpers_1.createUIElement)('CopyInput', (_a, ref) => {
    var { className, disabled = false, value, buttonText = 'Copy', icon = react_1.default.createElement(icons_1.CopyIcon, null), size, onFocus, onBlur, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: dataSelectorId } = _a, rest = __rest(_a, ["className", "disabled", "value", "buttonText", "icon", "size", "onFocus", "onBlur", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const copyToClipboard = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        if (!value) {
            return;
        }
        if (typeof navigator !== 'undefined' &&
            typeof ((_b = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _b === void 0 ? void 0 : _b.writeText) === 'function') {
            try {
                yield navigator.clipboard.writeText(value);
            }
            catch (e) {
                console.error(e);
            }
            return;
        }
        const text = value;
        const textarea = document.createElement('textarea');
        textarea.textContent = text;
        textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in MS Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand('copy'); // Some browsers may throw security exception.
        }
        catch (e) {
            console.error(e);
        }
        finally {
            document.body.removeChild(textarea);
        }
    }), [value]);
    return (react_1.default.createElement(StackView_1.StackView, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": dataSelectorId, align: StackView_1.STACK_ALIGN.center, gap: StackView_1.STACK_GAP.m, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-CopyInput', className) }),
        react_1.default.createElement(CopyInput_styles_1.StyledCopyInput, { "data-selector-id": "copy-input-control", disabled: disabled, size: size, value: value, readOnly: true, onFocus: onFocus, onBlur: onBlur }),
        react_1.default.createElement(Button_1.Button, { "data-selector-id": "copy-input-button", ui: Button_1.BUTTON_VIEW.text, disabled: disabled, onClick: copyToClipboard },
            react_1.default.createElement(Icon_1.Icon, { size: Icon_1.ICON_SIZES.m, src: icon }),
            buttonText)));
});
//# sourceMappingURL=CopyInput.js.map